import { Star } from "lucide-react";

// Infinite CSS marquee band.
export function Marquee({ items, className = "", duration = 30, reverse = false, bg = "bg-maroon", text = "text-cream" }) {
  const content = (
    <span className="inline-flex items-center">
      {items.map((it, i) => (
        <span key={i} className="inline-flex items-center">
          <span className="mx-8 font-playfair text-3xl md:text-5xl">{it}</span>
          <Star className="h-4 w-4 md:h-5 md:w-5 text-gold shrink-0" fill="currentColor" />
        </span>
      ))}
    </span>
  );
  return (
    <div data-testid="marquee" className={`relative overflow-hidden py-6 md:py-8 ${bg} ${text} ${className}`}>
      <div className={`marquee-track ${reverse ? "reverse" : ""}`} style={{ "--marquee-duration": `${duration}s` }}>
        {content}
        {content}
      </div>
    </div>
  );
}
